module.exports = __webpack_public_path__ + "static/media/integration.eee32127.svg";